import { render, staticRenderFns } from "./recUnit.vue?vue&type=template&id=2ed893ac&"
import script from "./recUnit.vue?vue&type=script&lang=js&"
export * from "./recUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports